module.exports = __webpack_public_path__ + "static/media/refer-badge.c410e409.svg";